import AllowancesService from '@sportOfferFederation/multi-market-select/services/AllowancesService';
import type { Selection } from '@superbet-group/betting.lib.validation';
import { Allowances } from '@sportOfferFederation/betSlip/allowances/Allowances';
import { featureLogger } from '@src/app/logger/featureLogger';

export function areMarketsAllowed(selection1: Selection, selection2: Selection): boolean {
    try {
        return Allowances.getInstance().validateSelection(selection1, selection2);
    } catch (error) {
        featureLogger.error(new Error(`Error in areMarketsAllowed ${error} ${AllowancesInitializedPromise}`));
        return false;
    }
}

export function areMaxSelectionsForEvent(selections: Selection[]): boolean {
    try {
        return Allowances.getInstance().validateMaxSelectionForEvent(selections);
    } catch (error) {
        featureLogger.error(new Error(`Error in areMaxSelectionsForEvent ${error} ${AllowancesInitializedPromise}`));
        return false;
    }
}

let resolveAllowancesInitialized: (value: void) => void;
let AllowancesInitializedPromise: Promise<void> | null = null;

// Async loading of config and the allowances checking function
export async function initAllowances(): Promise<void> {
    if (AllowancesInitializedPromise) {
        return AllowancesInitializedPromise;
    }
    AllowancesInitializedPromise = new Promise((resolve) => {
        resolveAllowancesInitialized = resolve;
    });
    const allowancesService = new AllowancesService();
    const config = await allowancesService.getAllowancesV2();

    Allowances.createInstance(config);

    resolveAllowancesInitialized();
}
